export default __webpack_public_path__ + "static/wsl-meshery-start-26d4260b8d29ac55a55b5455ba19b57c.webp";